var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallWine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#small-wine_svg__clip0)",
    fill: "#91C300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.77 2.5a1 1 0 000-2h-.006a.998.998 0 00-.997 1c0 .552.45 1 1.003 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.782 10.965L19.184.962a1 1 0 00-.988-.842H15.26a1 1 0 000 2h2.084l1.149 7.185c-2.114 1.116-5.237 1.007-7.15-.331C9.117 7.418 5.89 7.1 3.252 8.018l.943-5.898H6.28a1 1 0 000-2H3.342a1 1 0 00-.987.842L.756 10.965c-.42 2.627.322 5.215 2.09 7.288a10.59 10.59 0 006.923 3.63v7.376L4.651 33.3c-.932.735-1.312 1.96-.945 3.05.367 1.09 1.4 1.78 2.694 1.805h8.739c1.294-.024 2.326-.716 2.693-1.805.367-1.09-.012-2.315-.944-3.05L11.77 29.26v-7.377a10.592 10.592 0 006.924-3.63c1.768-2.072 2.51-4.66 2.09-7.287zM15.65 34.871c.31.244.367.607.288.841-.119.353-.513.437-.827.444H6.428c-.313-.007-.707-.09-.826-.444-.08-.234-.023-.597.288-.841l4.88-3.854 4.88 3.854zm1.522-17.917c-1.568 1.838-4.019 2.98-6.398 2.98h-.008c-2.378 0-4.83-1.142-6.397-2.98-1.382-1.619-1.963-3.634-1.637-5.673l.145-.903c2.111-1.217 5.355-1.14 7.32.235 1.4.979 3.197 1.468 4.994 1.468 1.255 0 2.51-.24 3.629-.716.297 2.01-.285 3.992-1.648 5.59z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "small-wine_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.641 .5)",
    d: "M0 0h20.3v38H0z"
  })))));
}

export default SvgSmallWine;